/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-03-17 15:58:00
 */

 import SnConfig from '../snConfig';
 import { Toast } from 'src/util/toast';
 import { default as CellOperate } from 'src/components/agGridComponent/cellOperate';
 import { ColDefCustom, default as AgGridVueCustomTsx } from 'src/components/agGridCustom/agGridVueCustomTsx';
 import SnConfigApi, { SnConfigDOI } from '../api/snConfigApi';
 import _ from 'lodash';
 import ListPageService from 'src/types/ListPage';
 import override from 'src/dectorators/override';
 import { QueryFormVOI } from 'src/components/queryForm/queryForm';
 import Input from 'src/types/iview/Input';
 import EnumEntity from 'src/enums/enumEntity';
 import CommonSelect from 'src/components/SelectCustom/commonSelect';
 import EnumUserStatus from 'src/enums/enumUserStatus';
 import EnumSex from 'src/enums/enumSex';
 import EntitySelect from 'src/components/SelectCustom/entitySelect';
 import alertSnOperateModal from '../snOperateModal';
 import EnumOperates from 'src/enums/enumOperates';
 import { IconBtnItem } from 'src/components/iconBtnGroup/iconBtnGroup';
 import CheckLogModal from '../Modal/checkLogModal'
 import alertFileOperateModal from '../fileOperateModal';

 export default class SnConfigService extends ListPageService {
    ctx: SnConfig;

    constructor(ctx: SnConfig) {
        super();
        this.ctx = ctx;
    }

    @override
    createColumns(): ColDefCustom[] {
        let t = this;
        return [
            {
                headerName: 'uuid号',
                field: 'sn',
                minWidth: 120,
            },
            // {
            //     headerName: 'uuid',
            //     field: 'uuid',
            //     minWidth: 120,
            // },
            {
                headerName: '客户名称',
                field: 'user_name',
                minWidth: 160,
            },
            {
                headerName: '客户手机号',
                field: 'user_phone',
                minWidth: 120,
                // maxWidth: 120,
            },
            {
                headerName: '激活时间',
                field: 'register_time',
                minWidth: 150,
                // maxWidth: 150,
            },
            {
                headerName: '状态',
                field: 'sn_status',
                minWidth: 75,
                // maxWidth: 75,
                cellRenderer(params) {
                    let data: SnConfigDOI.RowDataI = params.data;
                    return EnumUserStatus.findId(data.sn_status).getName();
                },
            },
            // {
            //     headerName: 'uuid状态',
            //     field: 'uuid_status',
            //     minWidth: 75,
            //     // maxWidth: 75,
            //     cellRenderer(params) {
            //         let data: SnConfigDOI.RowDataI = params.data;
            //         return EnumUserStatus.findId(data.uuid_status).getName();
            //     },
            // },
            {
                headerName: '操作',
                field: 'operate',
                minWidth: 400,
                cellRendererFramework: CellOperate,
                cellRendererFrameworkOpt: [
                    {
                        text: '修改',
                        async click(params) {
                            let data: SnConfigDOI.RowDataI = params.data;
                            let res = await alertSnOperateModal(EnumOperates.Update.getName(), data.id);
                            if (res) {
                                t.searchTable();
                            }
                        },
                    },
                    {
                        text: '删除',
                        async click(params) {
                            let res = await Toast.confirm();
                            if (!res) {
                                return;
                            }
                            let data: SnConfigDOI.RowDataI = params.data;
                            await t.delete([data.id]);
                        },
                    },
                    {
                        text: '激活',
                        disabled(params) {
                            let data: SnConfigDOI.RowDataI = params.data;
                            return data.sn_status == 0;
                        },
                        async click(params) {
                            let res = await Toast.confirm("激活","请确认是否激活");
                            if (!res) {
                                return;
                            }
                            let data: SnConfigDOI.RowDataI = params.data;
                            await t.onSn([data.id]);
                        },
                    },
                    {
                        text: '禁用',
                        disabled(params) {
                            let data: SnConfigDOI.RowDataI = params.data;
                            return data.sn_status == 1;
                        },
                        async click(params) {
                            let res = await Toast.confirm("禁用", "请确认是否禁用");
                            if (!res) {
                                return;
                            }
                            let data: SnConfigDOI.RowDataI = params.data;
                            await t.offSn([data.id]);
                        },
                    },
                    // {
                    //     text: 'uuid激活',
                    //     disabled(params) {
                    //         let data: SnConfigDOI.RowDataI = params.data;
                    //         return data.uuid_status == 0;
                    //     },
                    //     async click(params) {
                    //         let res = await Toast.confirm("激活","请确认是否激活");
                    //         if (!res) {
                    //             return;
                    //         }
                    //         let data: SnConfigDOI.RowDataI = params.data;
                    //         await t.uuidOnSn([data.id]);
                    //     },
                    // },
                    // {
                    //     text: 'uuid禁用',
                    //     disabled(params) {
                    //         let data: SnConfigDOI.RowDataI = params.data;
                    //         return data.uuid_status == 1;
                    //     },
                    //     async click(params) {
                    //         let res = await Toast.confirm("禁用", "请确认是否禁用");
                    //         if (!res) {
                    //             return;
                    //         }
                    //         let data: SnConfigDOI.RowDataI = params.data;
                    //         await t.uuidOffSn([data.id]);
                    //     },
                    // },
                    {
                        text: '日志查看',
                        async click(params) {
                            let data: SnConfigDOI.RowDataI = params.data;
                            CheckLogModal(data.sn)
                        },
                    },
                    {
                        text: '文件权限',
                        async click(params) {
                            let data: SnConfigDOI.RowDataI = params.data;
                            let res = await alertFileOperateModal(data.sn);
                        },
                    },
                ],
            },
        ];
    }


    @override
    creatQueryForm(): QueryFormVOI.DateItemType[] {
        return [
            {
                component: Input,
                label: 'uuid',
                field: 'sn',
                labelWidth: 25,
                props: { value: '', placeholder: 'uuid号' },
            },
            {
                component: Input,
                label: '客户名称',
                field: 'user_name',
                labelWidth: 70,
                props: { value: '', placeholder: '客户名称' },
            },
        ];
    }

    async delete(ids: number[]) {
        let { code } = await SnConfigApi.delete(ids[0]);
        if (code === 0) {
            Toast.success('删除成功');
            this.searchTable();
        }
    }

    async onSn(ids: number[]) {
        let { code } = await SnConfigApi.onSn(ids[0]);
        if (code === 0) {
            Toast.success('激活成功');
            this.searchTable();
        }
    }

    async offSn(ids: number[]) {
        let { code } = await SnConfigApi.offSn(ids[0]);
        if (code === 0) {
            Toast.success('禁用成功');
            this.searchTable();
        }
    }

    async uuidOnSn(ids: number[]) {
        let { code } = await SnConfigApi.uuidOnSn(ids[0]);
        if (code === 0) {
            Toast.success('激活成功');
            this.searchTable();
        }
    }

    async uuidOffSn(ids: number[]) {
        let { code } = await SnConfigApi.uuidOffSn(ids[0]);
        if (code === 0) {
            Toast.success('禁用成功');
            this.searchTable();
        }
    }

    @override
    initSearchParams(): void {
        this.ctx.searchParams = this.ctx.queryForm.getQueryObj<SnConfigDOI.QueryRowDataParamsI>();
        this.ctx.currentPage = 1;
    }

    @override
    async searchTable() {
        let ctx = this.ctx;
        let ag = this.ctx.$refs.ag as AgGridVueCustomTsx;
        ag.showLoading();
        let { code, data } = await SnConfigApi.searchList({
            ...ctx.searchParams,
            page_size: ctx.pageSize,
            page_index: ctx.currentPage,
        });
        ag.hideLoading();

        if (code === 0) {
            ctx.rowData = data.data_info || [];
            ctx.total = data.page_count;
        }
    }
 }